<template>
  <vs-collapse class="new_cstm_collapse_holder">
    <!-- <pre>{{ gradeSettingStructure }}</pre> -->
    <vs-collapse-item v-for="(setting, index) in gradeSettingStructure" :key="index">
      <div slot="header">
        <h4>{{ setting.subject }}</h4>
      </div>

      <vs-card v-if="setting.assignments.homework.all_assignments.length > 0" class="cstm_vx_card cstm-card">
        <div slot="header" class="flex flex-wrap justify-between items-center">
          <div class="inline-flex">
            <vs-checkbox :disabled="is_disabled" v-model="setting.assignments.homework.is_enabled" />
            <h4>Homework</h4>
          </div>
          <div class="inline-flex items-center">
            <b>Weightage</b>
            <vs-input @keypress="isNumeric" class="ml-5 w-16" :disabled="is_disabled || !setting.assignments.homework.is_enabled" v-model="setting.assignments.homework.total_weightage" />
          </div>
        </div>
        <vs-divider class="mt-0" />

        <div class="flex flex-1 items-center mt-4" v-for="homework in setting.assignments.homework.all_assignments" :key="homework.assignment_builder_id">
          <div>
            {{ homework.title }}
          </div>
          <div class="flex flex-1 items-center justify-end">
            Weightage
            <vs-input @keypress="isNumeric" class="ml-5 w-16" :disabled="is_disabled || !setting.assignments.homework.is_enabled" v-model="homework.weightage" />
          </div>
        </div>
      </vs-card>

      <vs-card v-if="setting.assignments.exam.all_assignments.length > 0" class="cstm_vx_card cstm-card">
        <div slot="header" class="flex flex-wrap justify-between items-center">
          <div class="inline-flex">
            <vs-checkbox :disabled="is_disabled" v-model="setting.assignments.exam.is_enabled" />
            <h4>Exam</h4>
          </div>
          <div class="inline-flex items-center">
            <b>Weightage</b>
            <vs-input @keypress="isNumeric" class="ml-5 w-16" :disabled="is_disabled || !setting.assignments.exam.is_enabled" v-model="setting.assignments.exam.total_weightage" />
          </div>
        </div>
        <vs-divider class="mt-0" />

        <div class="flex flex-1 items-center mt-4" v-for="exam in setting.assignments.exam.all_assignments" :key="exam.assignment_builder_id">
          <div>
            {{ exam.title }}
          </div>
          <div class="flex flex-1 items-center justify-end">
            Weightage
            <vs-input @keypress="isNumeric" class="ml-5 w-16" :disabled="is_disabled || !setting.assignments.exam.is_enabled" v-model="exam.weightage" />
          </div>
        </div>
      </vs-card>

      <div v-if="edit_permission() && (setting.assignments.homework.all_assignments.length > 0 || setting.assignments.exam.all_assignments.length > 0)" class="flex flex-1 justify-end">
        <vs-button @click="saveGradeSettings(index)">Save</vs-button>
      </div>
    </vs-collapse-item>
  </vs-collapse>
</template>

<script>
import { 
  getGradeStructure, 
  getGradeSettings,
  saveGradeSettings 
} from '@/api/classes'

export default {
  name: 'GradeSettings',
  props: ['class_id', 'edit_permission'],
  computed: {
    is_disabled () {
      return !this.edit_permission()
    }
  },
  data () {
    return {
      customer_id: localStorage.getItem('customer_id'),
      gradeSettingStructure: []
    }
  },
  created () {
    this.getGradeStructure()
  },
  methods: {
    async getGradeStructure () {
      try {
        const payload = { class_id: this.class_id }
        const response = await getGradeStructure(payload)

        if (response.data.data) {
          this.gradeSettingStructure = await this.modifyStructure(response.data.data)
        }

      } catch (e) {
        console.log(e)
      }
    },
    removeDuplicates (unfiltered_array) {
      const filtered_array = unfiltered_array.filter((el, index, self) => index === self.findIndex((t) => (
        t.subject_id === el.subject_id
      )))

      return filtered_array
    },
    async modifyStructure (unfiltered_array) {
      const filtered_array = this.removeDuplicates(unfiltered_array)

      try {
        const payload = { class_id: this.class_id }
        const response = await getGradeSettings(this.customer_id, payload)
        const gradeRules = response.data.data.gradeRules

        const newStructure = filtered_array.map(element => {
          return {
            ...element,
            assignments: {
              homework: {
                is_enabled: false,
                total_weightage: 0,
                assignment_type_id: 2,
                all_assignments: element.assignments.homework.map(item => ({...item, weightage: 0}))
              },
              exam: {
                is_enabled: false,
                total_weightage: 0,
                assignment_type_id: 4,
                all_assignments: element.assignments.exam.map(item => ({...item, weightage: 0}))
              }
            }
          }
        })

        if (gradeRules.length > 0) {
          gradeRules.map(rule => {
            const index = newStructure.findIndex(item => item.subject_id === rule.subject_id)

            if (index > -1) {
              if (rule.assignment_type_id === 2) {
                // Homework
                newStructure[index].assignments.homework.is_enabled = true
                newStructure[index].assignments.homework.total_weightage = rule.total_grade

                const assignmentIndex = newStructure[index].assignments.homework.all_assignments.findIndex(assignment => assignment.assignment_builder_id === rule.assignment_builder_id)
                if (assignmentIndex > -1) {
                  newStructure[index].assignments.homework.all_assignments[assignmentIndex].weightage = rule.percentage
                }
              }

              if (rule.assignment_type_id === 4) {
                // Exam
                newStructure[index].assignments.exam.is_enabled = true
                newStructure[index].assignments.exam.total_weightage = rule.total_grade

                const assignmentIndex = newStructure[index].assignments.exam.all_assignments.findIndex(assignment => assignment.assignment_builder_id === rule.assignment_builder_id)
                if (assignmentIndex > -1) {
                  newStructure[index].assignments.exam.all_assignments[assignmentIndex].weightage = rule.percentage
                }
              }
            }
          })
        }

        return newStructure
      } catch (e) {
        console.log(e)
      }
    },
    async saveGradeSettings (settings_index) {
      let flag = false

      try {
        const payload = {
          class_id: this.class_id,
          grade_components: []
        }

        // const settings = this.gradeSettingStructure[settings_index]

        this.gradeSettingStructure.map((settings, index) => {
          let homework_assignments_total_weightage = 0
          let exam_assignments_total_weightage = 0
          let assignment_group_total_weightage = 0

          // Homework
          if (settings.assignments.homework.is_enabled) {
            assignment_group_total_weightage += parseInt(settings.assignments.homework.total_weightage)

            const homework_components = settings.assignments.homework.all_assignments.map(component => {
              homework_assignments_total_weightage += parseInt(component.weightage)

              return {
                subject_id: settings.subject_id,
                assignment_type_id: settings.assignments.homework.assignment_type_id,
                percentage: component.weightage,
                total_grade: settings.assignments.homework.total_weightage,
                assignment_builder_id: component.assignment_builder_id
              }
            })

            payload.grade_components = [...payload.grade_components, ...homework_components]
          }
          
          // Exam
          if (settings.assignments.exam.is_enabled) {
            assignment_group_total_weightage += parseInt(settings.assignments.exam.total_weightage)

            const exam_components = settings.assignments.exam.all_assignments.map(component => {
              exam_assignments_total_weightage += parseInt(component.weightage)

              return {
                subject_id: settings.subject_id,
                assignment_type_id: settings.assignments.exam.assignment_type_id,
                percentage: component.weightage,
                total_grade: settings.assignments.exam.total_weightage,
                assignment_builder_id: component.assignment_builder_id
              }
            })

            payload.grade_components = [...payload.grade_components, ...exam_components]
          }

          // Checking the block where user hits save button
          if (settings_index === index) {
            if (settings.assignments.homework.is_enabled && homework_assignments_total_weightage !== 100) {
              flag = true
              this.showSuccessMessage('Error', 'The total of all homeworks weightage should be 100', 'danger')
            } else if (settings.assignments.exam.is_enabled && exam_assignments_total_weightage !== 100) {
              flag = true
              this.showSuccessMessage('Error', 'The total of all exams weightage should be 100', 'danger')
            } else if (settings.assignments.homework.is_enabled && parseInt(settings.assignments.homework.total_weightage) === 0) {
              flag = true
              this.showSuccessMessage('Error', 'The total of homework weightage cannot be 0', 'danger')
            } else if (settings.assignments.exam.is_enabled && parseInt(settings.assignments.exam.total_weightage) === 0) {
              flag = true
              this.showSuccessMessage('Error', 'The total of exam weightage cannot be 0', 'danger')
            } else if (settings.assignments.homework.is_enabled && settings.assignments.exam.is_enabled && assignment_group_total_weightage !== 100) {
              flag = true
              this.showSuccessMessage('Error', 'The total of all selected assignments weightage should be 100', 'danger')
            } else if (settings.assignments.homework.is_enabled && !settings.assignments.exam.is_enabled && assignment_group_total_weightage !== 100) {
              flag = true
              this.showSuccessMessage('Error', 'The total of all selected assignments weightage should be 100', 'danger')
            } else if (!settings.assignments.homework.is_enabled && settings.assignments.exam.is_enabled && assignment_group_total_weightage !== 100) {
              flag = true
              this.showSuccessMessage('Error', 'The total of all selected assignments weightage should be 100', 'danger')
            } else if (assignment_group_total_weightage !== 100) {
              flag = true
              this.showSuccessMessage('Error', 'The total of all selected assignments weightage should be 100', 'danger')
            } else {
              flag = false
            }    
          }
        }) 

        console.log('payload', payload)

        if (!flag) {
          const response = await saveGradeSettings(this.customer_id, payload)

          if (response.status === 202) {
            this.showSuccessMessage('Success', 'Grade settings saved successfully', 'success')
          }
        }
      } catch (e) {
        this.showSuccessMessage('Error', e.data.message, 'danger')
      }
    },
    isNumeric (event) {
      if (event.key >= 0 && event.key <= 9) {
        return true
      } else {
        event.preventDefault()
      }
    }
  }
}
</script>